import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from "@sentry/react";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './context/app';
import { UserProvider } from './context/user';
import { InterviewProvider } from './context/interview';

Sentry.init({
  dsn: "https://a93c9b8561edc9de185619b8cb3ef317@o1088143.ingest.us.sentry.io/4509747737591808",
  environment: process.env.NODE_ENV || "development",
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 1.0,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
});

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <UserProvider>
      <InterviewProvider>
        <App />
      </InterviewProvider>
      </UserProvider>
    </AppProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
